<template>
  <!--单图上传-->
  <el-upload
    v-if="uploadtype=='img'"
    uploadimg
    class="singleimg-uploader"
    accept="image/*"
    :[rawhttp]="customUpload"
    :show-file-list="false"
    :action="uploadUrl"
    :on-success="uploadSuccess"
    :on-error="handleError"
    :before-upload="handleBeforeUpload"
    :on-progress="handleProgress"
    :data="data"
    :headers="headers"
    :name="filename"
    single
  >
    <img v-if="imgurl&&!uploading" :src="imgurl" class="singleimg">
    <!--不能用v-else，因为上传进度完成之后还有一段加载时间，此时地址已经有了会显示出以下提示-->
    <i v-if="!imgurl&&!uploading" class="el-icon-plus singleimg-uploader-icon"></i>
    <el-progress v-if="uploading" :percentage="percent" type="circle" class="singleimg progress"></el-progress>
    <div slot="tip" v-if="showtips" class="el-upload__tip" v-text="getTips()"></div>
  </el-upload>
  <el-upload
    uploadimg
    v-else-if="uploadtype=='imglist'"
    drag
    list-type="picture"
    :[rawhttp]="customUpload"
    :limit="Number(maxlength)"
    :file-list="imglist"
    :on-remove="handleRemove"
    :action="uploadUrl"
    accept="image/*"
    :on-success="uploadSuccess"
    :on-error="handleError"
    :on-preview="showPicDialog"
    :on-exceed="onExceed"
    :before-upload="handleBeforeUpload"
    :data="data"
    :headers="headers"
    :name="filename"
    multiple>
    <i class="el-icon-upload"></i>
    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
    <div class="el-upload__tip" v-if="showtips" slot="tip" v-text="getTips()"></div>
  </el-upload>
  <el-upload
  v-else-if="uploadtype=='imgcard'"
  uploadimgcard
  multiple
  :action="uploadUrl"
  list-type="picture-card"
  :on-success="uploadSuccess"
  :on-preview="showPicDialog"
  :on-remove="handleRemove">
  <i class="el-icon-plus"></i>
  </el-upload>
  <el-upload
    v-else-if="uploadtype=='fileurl'"
    uploadfile
    single
    ref="upload"
    :[rawhttp]="customUpload"
    :accept="accept"
    :file-list="filelist"
    :action="uploadUrl"
    :on-success="uploadSuccess"
    :on-error="handleError"
    :on-remove="handleRemove"
    :before-upload="handleBeforeUpload"
    :data="data"
    :headers="headers"
    :name="filename"
  >
    <el-button size="small" type="primary">{{ btntext }}</el-button>
    <!--<el-progress v-if="uploading" :percentage="percent" :text-inside="true" style="width: 100%"></el-progress>-->
    <div slot="tip" v-if="showtips" class="el-upload__tip" v-text="getTips()"></div>
  </el-upload>
  <el-upload
    v-else-if="uploadtype=='filelist'"
    :file-list="filelist"
    drag
    uploadfile
    multiple
    :[rawhttp]="customUpload"
    :limit="Number(maxlength)"
    :action="uploadUrl"
    :on-success="uploadSuccess"
    :on-error="handleError"
    :on-remove="handleRemove"
    :on-exceed="onExceed"
    :before-upload="handleBeforeUpload"
    :data="data"
    :headers="headers"
    :name="filename"
  >
    <i class="el-icon-upload"></i>
    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
    <div slot="tip" v-if="showtips" class="el-upload__tip" v-text="getTips()"></div>
  </el-upload>
  <!--上传-->
  <el-upload
    v-else-if="uploadtype=='importfile'"
    uploadfile
    single
    ref="upload"
    :[rawhttp]="customUpload"
    :auto-upload="autoupload"
    :accept="accept"
    :file-list="filelist"
    :action="uploadUrl"
    :on-success="uploadSuccess"
    :on-error="handleError"
    :on-remove="handleRemove"
    :on-change="handleChange"
    :before-upload="handleBeforeUpload"
    :data="data"
    :headers="headers"
    :name="filename"
  >
    <el-button slot="trigger" size="small" type="primary">{{ btntext }}</el-button>
    <el-button size="small" type="success" v-if="showbeginbtn&&autoupload==false" @click="submitUpload">{{ beginbtntext }}</el-button>
    <!--<el-progress v-if="uploading" :percentage="percent" :text-inside="true" style="width: 100%"></el-progress>-->
    <div slot="tip" v-if="showtips" class="el-upload__tip" v-text="getTips()"></div>
  </el-upload>
  <el-upload
    v-else-if="uploadtype=='importlist'"
    class="my-upload"
    :accept="accept"
    :file-list="filelist"
    :[rawhttp]="customUpload"
    :limit="Number(maxlength)"
    :show-file-list="toshowlist"
    :action="uploadUrl"
    :on-success="uploadSuccess"
    :on-error="handleError"
    :before-upload="handleBeforeUpload"
    :on-progress="handleProgress"
    :data="data"
    :headers="headers"
    :name="filename"
    multiple
  >
    <el-button size="small" type="primary">{{ btntext }}</el-button>
    <div slot="tip" v-if="showtips" class="el-upload__tip" v-text="getTips()"></div>
  </el-upload>
</template>
<script>
import Vue from "vue";
import $ from "jquery";
import hUrl from "@/utils/url";

const OSS = require('ali-oss');
export default {
  name: 'MyUpload',
  model: {
    prop: 'inputval',
  },
  props: {
    maxlength: {
      type: [String, Number],
      default: 999999999
    },
    inputval: {},
    showtips: {
      type: [Boolean],
      default: true
    },
    btntext: {
      type: [String],
      default: '点击上传'
    },
    beginbtntext: {
      type: [String],
      default: '点击上传'
    },
    tips: {
      type: [String],
      default: ''
    },
    acceptfiles: {
      type: [String],
      default: 'jpg;jpeg'
    },
    acceptsize: {
      type: [String],
      default: '2M'
    },
    path: {
      type: [String],
      default() {
        return 'data.url';
      }
    },
    filename: {
      type: [String],
      default() {
        return 'file';
      }
    },
    uploadtype: {
      type: [String],
      default() {
        return 'img';
      }
    },
    uploadapply: {
      type: [Object],
      default() {
        return {dist: 'aliyun'};
      }
    },
    headers: {
      type: [Object],
      default() {
        return {};
      }
    },
    customuploadurl: {
      type: [String],
      default: ''
    },
    usealimedia: {
      type: [Boolean],
      default: false
    },
    useoss: {
      type: [Boolean],
      default: false
    },
    showlist: {
      type: [Boolean],
      default: false
    },
    uploadsingle: {
      type: [Boolean],
      default: true
    },
    autoupload: {
      type: [Boolean],
      default: true
    },
    uploadcheck: {
      type: [Function],
      default: function () {

      }
    }
  },
  data() {
    return $.extend(true, {
      ossparam: {},
      alimediaparam: {},
    }, this.getDefData(), {
      percent: 0,
      uploading: false,
      showbeginbtn: false,
      imgurl: '',
      imglist: [],
      fileurl: '',
      filelist: [],
      fileurllist: [],
      readyfiles: [],
      uploadlen: 0,
      toshowlist: this.showlist,
      data: this.uploadapply,
      imgmaxsize: 500 * 1000,//500kb
    }, this.getFromParent())
  },
  watch: {
    inputval(a, b, c) {
      var parent = this.getFromParent();
      //用extend时不能带true，否则会出现无法重新渲染的，原因可能是陷入死循环
      $.extend(this, parent);
//        this.imgurl=parent.imgurl;
//        this.imglist=parent.imglist;
//        this.fileurl=parent.fileurl;
//        this.filelist=parent.filelist;
    },
    uploadapply(newval) {
      this.data = $.extend(true, {}, newval || {});
    }
  },
  computed: {
    // 计算属性的 getter
    rawhttp: function () {
      // `this` 指向 vm 实例
      return this.useoss || this.usealimedia ? 'http-request' : '';
    },
    accept: function () {
      var arr = this.acceptfiles.split(';');
      var strarr = [];
      for (var i = 0; i < arr.length; i++) {
        var obj = arr[i];
        if (obj.indexOf('*') > -1) {
          strarr.push(obj);
        } else {
          strarr.push('.' + obj);
        }
      }
      return strarr.join(',');
    }
  },
  methods: {
    getFromParent() {
      var data = {};
      if (this.uploadtype == 'img') {
        data.imgurl = this.inputval;
        this.appendPicParam(data, 'imgurl');
      }
      if (this.uploadtype == 'fileurl') {
        data.fileurl = this.inputval;
      }
      if (this.uploadtype == 'importfile') {
        data.fileurl = this.inputval;
      }
      if (this.uploadtype == 'imglist') {
        var arr = [], inputarr = this.inputval || [];
        for (var i = 0; i < inputarr.length; i++) {
          arr.push({url: inputarr[i]});
        }
        data.imglist = arr;
        this.appendPicParam(data.imglist, 'url');
      }
      if (this.uploadtype == 'filelist') {
        var inputarr = this.inputval || [];
        data.filelist = $.extend(true, [], inputarr);
      }
      if (this.uploadtype == 'importlist') {
        var inputarr = this.inputval || [];
        data.filelist = $.extend(true, [], inputarr);
      }
      if (this.customuploadurl) {
        data.uploadUrl = this.customuploadurl;
      }
      return data;
    },
    syncToParent() {
      var data;
      if (this.uploadtype == 'img') {
        data = this.imgurl;
        this.removePicParam(data, 'imgurl');
      } else if (this.uploadtype == 'imglist') {
        data = $.pluck(this.imglist, 'url');
        this.removePicParam(data, 'url');
      } else if (this.uploadtype == 'fileurl') {
        data = this.fileurl;
      } else if (this.uploadtype == 'importfile') {
        data = this.fileurl;
      } else if (this.uploadtype == 'filelist') {
        data = this.filelist;
      } else if (this.uploadtype == 'importlist') {
        data = this.filelist;
      }
      this.$emit('input', data);
      this.$emit('uploadsuccess', data);
      if (this.uploadtype == 'importlist') {
        this.toshowlist = this.showlist || false;//若初始是希望显示的则显示
      }
    },
    uploadSuccess(res, file, filelist) {
      this.uploading = false;
      file.url = this.getFieldVal(res, this.path);
      if (this.uploadtype == 'img') {
        this.imgurl = file.url;
      } else if (this.uploadtype == 'imglist') {
        this.imglist = filelist;
      }
      if (this.uploadtype == 'fileurl') {
        this.fileurl = file.url;
        this.filelist = [file];
      } else if (this.uploadtype == 'filelist') {
        this.filelist = filelist;
      } else if (this.uploadtype == 'importlist') {
        this.filelist = filelist;
      } else if (this.uploadtype == 'importfile') {
        this.fileurl = file.url;
        this.filelist = [file];
      }
      this.uploadlen--;
      if (this.uploadlen == 0) {
        this.syncToParent();
      }
    },
    client() {
      var client = new OSS(this.ossparam);  //后端提供数据
      return client
    },
    customUpload(option) {
      var that = this;
      if (this.useoss) {
        this.ossUpload(option);
      } else if (this.usealimedia) {
        this.alimediaUpload(option);
      }
    },
    createUploader(option) {
      let self = this;
      let uploader = new AliyunUpload.Vod({
        userId: self.alimediaparam.user_id,
        timeout: 60000,
        partSize: 1048576,
        parallel: 5,
        retryCount: 3,
        retryDuration: 2,
        // 添加文件成功
        addFileSuccess: function (uploadInfo) {
        },
        // 开始上传
        onUploadstarted: function (uploadInfo) {
          // 如果是 UploadAuth 上传方式, 需要调用 uploader.setUploadAuthAndAddress 方法
          // 如果是 UploadAuth 上传方式, 需要根据 uploadInfo.videoId是否有值，调用点播的不同接口获取uploadauth和uploadAddress
          // 如果 uploadInfo.videoId 有值，调用刷新视频上传凭证接口，否则调用创建视频上传凭证接口
          // 注意: 这里是测试 demo 所以直接调用了获取 UploadAuth 的测试接口, 用户在使用时需要判断 uploadInfo.videoId 存在与否从而调用 openApi
          // 如果 uploadInfo.videoId 存在, 调用 刷新视频上传凭证接口(https://help.aliyun.com/document_detail/55408.html)
          // 如果 uploadInfo.videoId 不存在,调用 获取视频上传地址和凭证接口(https://help.aliyun.com/document_detail/55407.html)
          uploader.setUploadAuthAndAddress(uploadInfo,
            self.alimediaparam.UploadAuth
            , self.alimediaparam.UploadAddress, self.alimediaparam.VideoId);
        },
        // 文件上传成功
        onUploadSucceed: function (uploadInfo) {
//              console.log(uploadInfo);
          option.onSuccess({data: {url: uploadInfo.videoId}});
        },
        // 文件上传失败
        onUploadFailed: function (uploadInfo, code, message) {
          option.onError("上传失败");
        },
        // 取消文件上传
        onUploadCanceled: function (uploadInfo, code, message) {
        },
        // 文件上传进度，单位：字节, 可以在这个函数中拿到上传进度并显示在页面上
        onUploadProgress: function (uploadInfo, totalSize, progress) {
          option.onProgress({percent: progress * 100});
        },
        // 上传凭证超时
        onUploadTokenExpired: function (uploadInfo) {
          uploader.resumeUploadWithAuth(self.alimediaparam.UploadAuth);
        },
        // 全部文件上传结束
        onUploadEnd: function (uploadInfo) {
        }
      })
      return uploader;
    },
    alimediaUpload(option) {
      var uploader = this.createUploader(option);
      uploader.addFile(option.file, null, null, null, null);
      uploader.startUpload();
    },
    ossUpload(option) {
      var that = this;
      var fileName = 'images/' + option.file.uid;
      this.client().multipartUpload(fileName, option.file, {
          progress: function (p) { // 获取进度条的值
//              console.log(p)
            option.onProgress({percent: p * 100});
          }
        }
      ).then(
        result => {
//            console.log(result)
          if (result.res.statusCode === 200) {
            let url = result.res.requestUrls[0]
            url = url.indexOf('?') > 0 ? url.substring(0, url.indexOf('?')) : url; //过滤掉url中的参数部分
            option.onSuccess({data: {url: url}});
          } else {
            option.onError("上传失败");
          }
        })
    },
    submitUpload() {
      if (this.uploadtype == 'importfile') {
        this.uploadcheck(this.filelist, () => {
          this.$refs.upload.submit();
        })
      }
    },
    handleRemove(file, fileList) {
      if (this.uploadtype == 'imglist') {
        if (file.size > this.imgmaxsize) {//因为超大小而被自动移除的不必同步，否则会导致element进度执行出错
          return false;
        }
        this.imglist.splice(this.imglist.indexOf(file), 1);
      }
      if (this.uploadtype == 'fileurl') {
        this.fileurl = "";
        this.filelist.splice(this.filelist.indexOf(file), 1);
      }
      if (this.uploadtype == 'importfile') {
        this.fileurl = "";
        this.filelist.splice(this.filelist.indexOf(file), 1);
      }
      if (this.uploadtype == 'filelist') {
        this.filelist.splice(this.filelist.indexOf(file), 1);
      }
      this.uploadlen--;
      this.showbeginbtn = this.uploadlen > 0;
      this.syncToParent();
    },
    handleBeforeUpload(rawfile) {
      if ((this.uploadtype == 'img' || this.uploadtype == 'imglist')
        && rawfile.size > this.imgmaxsize) {
        this.error('{1}大于500kb'.format(rawfile.name));
        return false;
      }
      if (this.useoss) {
        $.ajax({
          type: "post",
          url: hUrl + 'common/alists',
          cache: false,
          async: false,
          timeout: 10000,//10秒超时
          success: (res) => {
            if (res.code == 200) {
              this.uploadUrl = res.data.url || "";
              this.ossparam.region = this.getFieldVal(res.data, 'region_id');
//              this.ossparam.endpoint="https://oss-cn-beijing.aliyuncs.com";
              this.ossparam.bucket = this.getFieldVal(res.data, 'bucket');
              this.ossparam.accessKeyId = this.getFieldVal(res.data, 'Credentials.AccessKeyId');
              this.ossparam.accessKeySecret = this.getFieldVal(res.data, 'Credentials.AccessKeySecret');
              this.ossparam.expiration = this.getFieldVal(res.data, 'Credentials.Expiration');
              this.ossparam.stsToken = this.getFieldVal(res.data, 'Credentials.SecurityToken');
            }
          },
          error: (e) => {
            this.msg('请求上传地址出错,使用旧上传地址' + this.uploadUrl);
          }
        });
      } else if (this.usealimedia) {
        var postdata = {
          title: rawfile.name,
          file_name: rawfile.name
        };
        $.ajax({
          type: "post",
          url: hUrl + 'common/alivod/createuploadvideo',
          cache: false,
          async: false,
          data: postdata,
          timeout: 10000,//10秒超时
          success: (res) => {
            if (res.code == 200) {
              this.alimediaparam = $.extend(true, {}, res.data);
            }
          },
          error: (e) => {
            this.error('请求上传地址出错,使用旧上传地址' + this.uploadUrl, 'error');
          }
        });
      }
      this.uploading = true;
      this.imgurl = '';
      this.percent = 0;
      this.uploadlen++;
      this.$emit('beforeupload');
      if (this.uploadtype == 'importlist') {
        this.toshowlist = true;
      }
    },
    handleChange(file, fileList) {
      if (this.uploadtype == 'importfile') {
        this.showbeginbtn = fileList.length > 0;
        if (this.filelist.indexOf(file) == -1) {
//            this.filelist.push(file);
        }
      }
    },
    handleError() {
      this.uploadlen--;
    },
    handleProgress(event) {
      this.percent = event.percent;
    },
    onExceed(files, fileList) {
      this.warning('不能超过{1}个'.format(this.maxlength));
    },
    getTips() {
      if (this.tips) {
        return this.tips;
      } else {
        if (this.uploadtype == 'img') {
          return '只能上传{1}文件{2}'.format(this.acceptfiles, '');
        } else if (this.uploadtype == 'imglist') {
          return '只能上传{1}文件{2}'.format(this.acceptfiles, '，且不超过{1}'.hformat(this.acceptsize));
        } else if (this.uploadtype == 'fileurl') {
          return '只能上传{1}文件{2}'.format(this.acceptfiles, '，且不超过{1}'.hformat(this.acceptsize));
        } else if (this.uploadtype == 'filelist') {
          return '只能上传{1}文件{2}'.format(this.acceptfiles, '，且不超过{1}'.hformat(this.acceptsize));
        } else if (this.uploadtype == 'importfile') {
          return '只能上传{1}文件{2}'.format(this.acceptfiles, '，且不超过{1}'.hformat(this.acceptsize));
        }
      }
    }
  }

}
</script>
<style lang="scss">
[uploadimgcard] {
  min-height: 150px;
  position: relative;
}

[uploadimgcard] .el-upload-list.el-upload-list--picture-card {
}

[uploadimgcard] .el-upload.el-upload--picture-card {
  position: absolute;
  top: 0;
  left: 0;
}

/*屏蔽批量上传图片时预览状态*/
ul.el-upload-list--picture
li.el-upload-list__item.is-success.el-list-leave.el-list-leave-active, ul.el-upload-list--picture li.el-upload-list__item.is-uploading.el-list-move.el-list-leave.el-list-leave-active, ul.el-upload-list--picture li.el-upload-list__item.is-success.el-list-enter.el-list-enter-active, ul.el-upload-list--picture li.el-upload-list__item.is-uploading.el-list-leave.el-list-leave-active, ul.el-upload-list--picture li.el-upload-list__item.is-success.el-list-leave-active.el-list-move.el-list-leave-to, ul.el-upload-list--picture li.el-upload-list__item.is-uploading.el-list-leave-active.el-list-leave-to, ul.el-upload-list--picture li.el-upload-list__item.is-ready {
  display: none;
}

.my-upload {
  .el-upload__tip {
    word-wrap: break-word;
    word-break: break-all;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/MyUpload.vue